module.exports = __webpack_public_path__ + "img/icon-founded-lightblue.98a6b4e9.svg";